<template>
    <section class="shops-card">
        <div class="shops-card__header">
            <p class="shops-card__address">
                <span>{{ result.address }}</span>
            </p>
            <p class="shops-card__phone">
                <span>{{ result.phone }}</span>
            </p>
            <p class="shops-card__works">
                <span>{{ result.schedule }}</span>
            </p>
            <DefLink @click="isOpen = !isOpen">
                {{ messages.showMap }}
            </DefLink>
        </div>
        <SlideUpDown v-model="isOpen">
            <div class="shops-card__main">
                <DefMap>
                    <div v-for="store in [result]"
                         :lat="store.gpsN"
                         :lng="store.gpsS"
                         class="def-map-popup"
                    >
                        <h6 class="def-map-popup__title">{{ store.address }}</h6>
                        <p class="def-map-popup__text">{{ store.phone }}</p>
                        <p class="def-map-popup__text">{{ store.schedule }}</p>
                    </div>

                </DefMap>
            </div>

        </SlideUpDown>
    </section>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue';
import { useStore } from 'vuex';
import DefLink from "../def/DefLink/DefLink";
import DefMap from "../def/DefMap/DefMap";

const { result } = defineProps(['result']);
const { state } = useStore();

const isOpen = ref(false);

const messages = computed(() => state.stores.data.messages);


</script>

<script>
export default {
    name: 'ShopsCard'
}
</script>

<style lang="scss" scoped>
.shops-card{
    border: 1px solid #CACECE;
    padding: 16px;
    @include point-md{
        padding: 30px 24px;
    }
    &__header{
        display: grid;
        align-items: center;
        grid-template-columns: 1fr;
        grid-template-areas:
            "address"
            "phone"
            "works"
            "show";
        grid-row-gap: 8px;
        @include point-md{
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                "address phone show"
                "address works show";
            grid-row-gap: 4px;
        }
        @include point-lg{
            grid-template-columns: repeat(3, 2fr) 1fr;
            grid-template-areas: "address phone works show";
        }
        :deep(.def-link-component){
            grid-area: show;
            font-size: rem(12);
            font-weight: 500;
            @include point-md{
                justify-self: flex-end;
            }
        }
    }
    &__address{
        grid-area: address;
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        margin-bottom: 8px;
        @include point-md{
            margin-bottom: 0;
        }
    }
    &__phone,
    &__works{
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        color: var(--color-dark-grey);
    }
    &__phone{
        grid-area: phone;
    }
    &__works{
        grid-area: works;
        margin-bottom: 12px;
        @include point-md{
            margin-bottom: 0;
        }
    }
    &__main{
        padding-top: 20px;
        @include point-md{
            padding-top: 28px;
        }
    }
    :deep(.def-map){
        height: 240px;
        @include point-md{
            height: 260px;
        }
        @include point-lg{
            height: 460px;
        }
    }
}
</style>